import { render, staticRenderFns } from "./bounty-coupon.vue?vue&type=template&id=86bcd2f4&scoped=true&lang=pug&"
import script from "./bounty-coupon.vue?vue&type=script&lang=js&"
export * from "./bounty-coupon.vue?vue&type=script&lang=js&"
import style0 from "./bounty-coupon.vue?vue&type=style&index=0&id=86bcd2f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86bcd2f4",
  null
  
)

export default component.exports